import { useWorkspaceId } from "../../workspace/useWorkspaceId";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import {
    BASE_API_URL,
    HttpError,
} from "../../api/utils/useGovernmentAgencyHubAppQueryClient";
import { useHttpGovernmentAgencyHubAppHeaders } from "../../api/utils/useHttpGovernmentAgencyHubAppHeaders";

interface UpdateDelegatedRequest {
    taxSubmissionId: string;
    delegatedTaxId: string | null;
}

export const useUpdateDelegated = () => {
    const workspaceId = useWorkspaceId();
    const headers = useHttpGovernmentAgencyHubAppHeaders({ method: "PATCH" });
    const queryClient = useQueryClient();
    const { t } = useTranslation();

    const mutation = useMutation({
        mutationFn: async (request: UpdateDelegatedRequest) => {
            const url = new URL(
                `${BASE_API_URL}/tenants/${workspaceId}/tax-submissions/${request.taxSubmissionId}/update-delegated`,
            );

            if (request.delegatedTaxId)
                url.searchParams.append(
                    "delegatedTaxId",
                    request.delegatedTaxId,
                );

            const response = await fetch(url, {
                headers,
                method: "PATCH",
            });

            if (!response.ok) {
                throw new HttpError(response);
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["useGetTaxSubmissionDetail"],
            });
        },
        meta: {
            errorMessage: t("components.delegated_updater.fail"),
        },
    });

    return mutation;
};
